import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  width: 100%;
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  padding: 16px;
  margin: 20px 0 16px 0px;
`;

export const CardContent = styled.div`
  flex: 1;
  padding-right: 16px;
`;

export const CardTitle = styled.div`
  color: var(--text-primary-n-600, #040222);

  /* Label/Small */
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const CardDescription = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ImageWrapper = styled.div`
  height: 75px;
  width: 75px;
  @media (max-width: 768px) {
    height: 64px;
    width: 64px;
  }
`;

export const RatingDistanceWrapper = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  padding: 4px 0;
`;

export const BadgesContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding-top: 12px;
`;

export const Badge = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #f5f0ff;
  color: var(--Purple-P500, #451999);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  width: fit-content;
  text-align: center;
`;

export const CardButton = styled.button`
  margin-top: 12px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: var(--Neutral-N0, #ffffff);
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--Neutral-N50, #f5f5f5);
    border-color: var(--text-primary-n-600, #040222);
  }

  &:active {
    background: var(--Neutral-N100, #e7e7f0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: var(--text-error, #e74c3c);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
`;

export const MakeListContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  overflow-x: scroll;
  margin-right: -16px;
  padding-right: 16px;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MakeItem = styled.div<{ isSelected?: boolean }>`
  display: flex;
  width: 55px;
  height: 55px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  aspect-ratio: 1/1;
  border-radius: 8px;
  background: #f5f5f5;
  cursor: pointer;
  border: ${(props) => (props.isSelected ? "1px solid var(--Button-Default, #0FA457)" : "none")};
`;
